import {Component} from '@angular/core';
import {ModalRef} from '../modal-ref';
import {IdentityService} from '../../../identity/identity.service';

@Component({
    selector: 'app-accep-agb-box',
    templateUrl: './accpet-agb-box.component.html',
    styleUrls: ['./accpet-agb-box.component.css'],
    standalone: false
})
export class AcceptAgbBoxComponent {

    readonly linkToAGB: string = $localize`:@@linkToAGB:https://www.clea.app/allgemeine-geschaeftsbedingungen-agbs/`;
    readonly linkToDSE: string = $localize`:@@linkToDSE:https://www.clea.app/datenschutzerklaerung-clea-assistenzplattform/`;

    agb = false;
    dse = false;

    constructor(
        private modal: ModalRef,
        private identity: IdentityService,
    ) {
    }

    get acceptedAll(): boolean {
        return this.agb && this.dse;
    }

    async ok(): Promise<void> {
        if (!this.acceptedAll) {
            return;
        }

        await this.identity.acceptAGB();

        this.modal.close();
    }
}
